import React, { lazy, Suspense } from 'react'
import { Switch, Route, Redirect } from 'wouter'
import { AUTH_REDIRECT_PATH, LOGIN_PATH, LOGOUT_PATH } from '@maui-mf/root/common-auth'

const Signin = lazy(() => import('./routes/Signin'))
const Signout = lazy(() => import('./routes/Signout'))
const AuthCallback = lazy(() => import('./routes/AuthCallback'))

export function Router() {
  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path={LOGIN_PATH} component={Signin} />
        <Route path={LOGOUT_PATH} component={Signout} />
        <Route path={AUTH_REDIRECT_PATH} component={AuthCallback} />
        <Route path="/auth/:unmatched*">
          <Redirect to={LOGIN_PATH} />
        </Route>
      </Switch>
    </Suspense>
  )
}
